import React, { useState, useEffect } from "react";

// Interfaces
import { ItemState } from "../../utils/interfaces/packages";

// Actions
import { cartActionDispatch } from "../../store/cart/actions";

// Selectors
import {
  selectBundleProductsSelector,
  selectVirtualProductsSelector,
} from "../../store/packages/selector";
import { selectCartSelector } from "../../store/cart/selector";
import { selectCurrencySelector } from "../../store/currency/selector";
import { selectPaymentFrequencyConfigSelector, selectStoreConfigSelector } from "../../store/storeConfig/selector";

import { PageTitle, CardLayout, Dialog, ProductList } from "../../components";
import {
  addBundleItemsToCart,
  addVirtualItemsToCart,
  removeAllItemFromCart,
} from "./serviceManager";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { router } from "../../utils/router";
import ProductPageConstants from "./constants.json";
import "./style.css";
import { CardLoader } from "../../components/loaders/productLoaders";
import HelperCardLayout from "./helperCardLayout";
import ComparisionTableLayout from "./comparisionTableLayout";
import FAQLayout from "./faqLayout";
import CounterSubsLayout from "./counterSubsLayout";
import PageLayout from "../pageLayout";
import { notificationActionDispatch } from "../../store/notification/actions";
import { Item } from "../../utils/interfaces/cart";
import fetchDataFromTelligent from "../../components/commonFunction";
import { baseRouterPath, productKey } from "../../utils/constants";
// import bundlePackages from './products.json';
import { OverlayLoader } from "../../components/loaders/overlayLoader";
import { addDataLayer, stripHtmlTags } from "../../utils/utility";
import { selectItemDL } from "../../utils/dataLayerManager";

const Products = () => {
  const { setCart } = cartActionDispatch(useAppDispatch());
  const { setNotification } = notificationActionDispatch(useAppDispatch());

  const storeData = useAppSelector(selectStoreConfigSelector);
  const cartData = useAppSelector(selectCartSelector);
  const currency = useAppSelector(selectCurrencySelector);
  const bundlePackages = useAppSelector(selectBundleProductsSelector);
  const virtualPackages = useAppSelector(selectVirtualProductsSelector);
  const paymentFrequency = useAppSelector(selectPaymentFrequencyConfigSelector);

  const [attorneySize, setAttorneySize] = useState(1);
  const [subscriptionType, setSubscriptionType] = useState("");
  const [selectedBundleProduct, setBundleProduct] = useState("");
  const [selectedVirtualProducts, setVirtualProducts] = useState(
    Array<ItemState>
  );
  const [open, setOpen] = React.useState(false);
  const [configLoader, setConfigLoader] = useState(false);
  const [packageLoader, setPackageLoader] = useState(true);
  const [contractLength, setContractLength] = useState("");
  const [bundleId, setBundleID] = useState("");
  const [telligentData, setTelligentData] = useState([]);
  const [virtualPackagesId, setVirtualPackagesId] = useState("");
  const [overlay, setOverlay] = useState(false);

  const selectBundleProduct = (id: string) => {
    let prod = bundlePackages.find((item) => item.sku === id);
    addDataLayer(selectItemDL(productKey.bundle_products_category_name, [prod], contractLength, attorneySize), "select_item");
    setBundleProduct(id);
    setBundleID(id);
  };

  useEffect(() => {
    let skuList = "";
    virtualPackages?.map((i) => {
      skuList = skuList.concat(i.sku + `,`);
    });
    setVirtualPackagesId(skuList);
  }, [virtualPackages]);

  useEffect(() => {
    if (bundleId.length > 0) {
      if (virtualPackages?.length > 0) {
        setOpen(true);
      } else {
        checkout();
      }
    }
  }, [bundleId]);

  const navigateToCart = () => {
    setOverlay(false);
    setBundleID("");
    router.navigate(`${baseRouterPath}/cart`); // navigate to checkout page
  };

  const addNewItemsToCart = async () => {
    await addBundleItemsToCart(
      cartData,
      selectedBundleProduct,
      bundlePackages,
      attorneySize,
      subscriptionType,
      setCart,
      setNotification,
      contractLength
    ).then(async () => {
      if (selectedVirtualProducts.length > 0) {
        await addVirtualItemsToCart(
          cartData,
          selectedVirtualProducts,
          attorneySize,
          subscriptionType,
          setCart,
          setNotification,
          contractLength
        ).then(() => {
          setConfigLoader(false);
          navigateToCart();
        });
      } else {
        setConfigLoader(false);
        navigateToCart();
      }
    });
  };

  const checkout = async () => {
    setOverlay(true);
    setConfigLoader(true);
    setOpen(false);
    if (cartData && cartData.total_quantity === 0) {
      addNewItemsToCart();
    } else {
      let qty = await removeAllItemFromCart(cartData, setCart, setNotification);
      if (qty === 0) {
        addNewItemsToCart();
      }
    }
  };

  const toggleVirtualProducts = (item: ItemState) => {
    let selectedIndex = selectedVirtualProducts?.findIndex(
      (product) => product?.sku === item?.sku
    );
    if (selectedIndex === -1)
      setVirtualProducts([...selectedVirtualProducts, item]);
    else
      setVirtualProducts(
        selectedVirtualProducts?.filter((product) => product?.sku !== item?.sku)
      );
  };

  const getSelectedBundleProduct = () => {
    let product = "";
    if (cartData && cartData.items) {
      cartData.items.forEach((item: Item) => {
        if (item.product.__typename === "BundleProduct")
          product = item.product.sku;
      });
    }
    return product;
  };

  const getPrice = (item: ItemState) => {
    // let price = item.options[0].title === subscriptionType
    if (item.ln_sl_lexis_ai_package === 0) {
      let option = item.options?.find(
        (option) => option.title.toLowerCase() === contractLength.toLowerCase());
      let price = 0;
      if(option) price = option.drop_down_option[attorneySize - 1].price;
      return price;
    }
  };

  useEffect(() => {
    // if (storeData && storeData.default_subscription_type)
    //   setSubscriptionType(storeData.default_subscription_type);
    // if (storeData && storeData.contract_length_options_monthly_default)
    //   setContractLength(storeData?.contract_length_options_monthly_default);
    if (paymentFrequency && paymentFrequency?.contract_details_json?.default_option)
      setContractLength(paymentFrequency?.contract_details_json?.default_option);
  }, [paymentFrequency]);

  useEffect(() => {
    if (bundlePackages && bundlePackages.length > 0) {
      setPackageLoader(false);
    }
    if (virtualPackages && virtualPackages.length > 0) {
      setPackageLoader(false);
    }
    if (cartData && cartData.items && cartData.items.length > 0) {
      cartData.items.forEach((item: Item) => {
        if (
          item.__typename === "BundleCartItem" &&
          selectedBundleProduct.length === 0
        ) {
          setBundleProduct(item.product.sku);
        }
        if (
          item.__typename === "VirtualCartItem" &&
          selectedBundleProduct.length === 0
        ) {
          const index = virtualPackages?.findIndex(
            (product: ItemState) => product.sku === item.product.sku
          );
          let virtualPack = selectedVirtualProducts;
          if (index > -1) {
            let selectedIndex = selectedVirtualProducts?.findIndex(
              (product) => product.sku === item.product.sku
            );
            if (selectedIndex === -1) {
              virtualPack.push(virtualPackages[index]);
              setVirtualProducts(virtualPack);
            }
          }
        }
      });
    }
  }, [virtualPackages, bundlePackages]);

  useEffect(() => {
    if (
      cartData &&
      cartData.custom_attributes &&
      cartData.custom_attributes.ln_sl_noattorney
    )
      setAttorneySize(cartData.custom_attributes.ln_sl_noattorney);      
    if (
      cartData &&
      cartData.custom_attributes &&
      cartData.custom_attributes.ln_sl_subscription_type
    )
    {
      if (cartData.custom_attributes.ln_sl_subscription_type.toLowerCase() === "monthly")
        setContractLength(
          paymentFrequency?.contract_details_json?.contract_details.find(contract => contract.code.includes(`${cartData.custom_attributes.ln_sl_subscription_month.toString()}-MONTH`)
        )?.code ?? "MONTHLY");
      else if(cartData.custom_attributes.ln_sl_subscription_type.toLowerCase() === "yearly")
        setContractLength(
          paymentFrequency?.contract_details_json?.contract_details.find(contract => contract.code.includes(`${cartData.custom_attributes.ln_sl_subscription_year.toString()}-YEAR`)
        )?.code ?? "YEARLY");
      else
        setSubscriptionType(cartData.custom_attributes.ln_sl_subscription_year.toString());
    } 
  }, [cartData]);

  const getTermDescription = () => {
    // return subscriptionType === "MONTHLY" ? ProductPageConstants.cardSubsLengthMsg.MONTHLY : ProductPageConstants.cardSubsLengthMsg.YEARLY
    return ProductPageConstants.cardSubsLengthMsg.contract.label.replace(
      "%d",
      paymentFrequency?.contract_details_json?.contract_details.find(contract => contract.code === contractLength)?.label ?? ""
    );
  };

  const getPriceSuffix = () => {
    // return subscriptionType === "MONTHLY" ? storeData.price_suffix_monthly : storeData.price_suffix_yearly
    return contractLength.includes("MONTH")
      ? storeData.price_suffix_monthly
      : storeData.price_suffix_yearly;
  };

  const featureList = bundlePackages.reduce(
    (acc, item) => {
      const featuresLength =
        item.ln_sl_inclusion_overview?.split(",").length || 0;
      return featuresLength > acc.maxLengthFeatureList
        ? { maxLengthFeatureList: featuresLength, featureList: item }
        : acc;
    },
    { maxLengthFeatureList: 0, featureList: null } as {
      maxLengthFeatureList: number;
      featureList: null | ItemState;
    }
  );

  const { maxLengthFeatureList } = featureList;

  useEffect(() => {
    if (virtualPackagesId === "") return;
    const fetchData = async () => {
      const response = await fetchDataFromTelligent(
        virtualPackagesId,
        storeData?.telligent_api_url
      );
      if (response) {
        setTelligentData(response);
      }
    };

    Boolean(storeData?.telligent_api_enabled) && fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [virtualPackagesId]);

  const cancelSelectedProduct = () => {
    setBundleID("");
    setOpen(false);
  };
  const getSelectedProductTitle = () => {
    const selectedBundleProduct = bundlePackages.find(
      (item) => item.sku === bundleId
    );
    return selectedBundleProduct?.name;
  };

  return (
    <PageLayout>
      {overlay && <OverlayLoader product={getSelectedProductTitle()} />}
      <PageTitle
        heading={storeData.homepage_main_header}
        subheading={storeData.homepage_sub_header}
        trailDuration={storeData.trial_duration}
      />
      <section className="nexis-container">
        <CounterSubsLayout
          paymentFrequencyConfig={paymentFrequency}
          attorneySize={attorneySize}
          setAttorneySize={setAttorneySize}
          storeData={storeData}
          subscriptionType={subscriptionType}
          setSubscriptionType={setSubscriptionType}
          changeContractLength={setContractLength}
          contractLength={contractLength}
        />

       <div className="subscription-selector-container flex flex-col items-center justify-around md:flex-wrap xl:flex-nowrap md:flex-row">
  {!packageLoader ? (
    bundlePackages.map((item: ItemState) => {
       let skuIds: string = '';
      item?.items?.forEach((items: any) => {
        items?.options?.forEach((option: any) => {
          if (option.product?.sku) {
        skuIds += `${option.product.sku},`;
       
          }
        });
      });
      skuIds = skuIds.slice(0, -1);  
 
      return (
        <CardLayout
          key={item.name}
          id={item.id}
          sku={item.sku}  
          price={getPrice(item) ?? 0}
          mvp={item?.ln_sl_is_most_popular ? 1 : 0}
          custom={item?.ln_sl_lexis_ai_package ? 1 : 0}
          customPriceInfo={item?.ln_sl_lexis_ai_price_info ?? ""}
          customPackageLink={item?.ln_sl_lexis_ai_cta}
          name={item.name}
          description={item.short_description.html}
          currency={currency.base_currency_symbol}
          suffix={getPriceSuffix()}
          features={
            item?.ln_sl_inclusion_overview
              ? stripHtmlTags(item.ln_sl_inclusion_overview).split(",") 
              : []
          }
          trial_message_summarycard={
            storeData.trial_message_summarycard?.replace(
              "%",
              storeData.trial_duration
            ) || ""
          }
          btnText={storeData.subscribe_now_button_text}
          trial_duration={parseInt(storeData.trial_duration)}
          isSelected={getSelectedBundleProduct()}
          selectCard={() => selectBundleProduct(item.sku)}
          termDescription={getTermDescription()}
          loader={configLoader}
          maxLengthOfFeatures={maxLengthFeatureList}
          virtualProductSku={skuIds}
          showTelligentData={storeData?.telligent_api_enabled === "1"}
        />
      );
    })
  ) : (
    <CardLoader />
  )}
</div>


      </section>
      {!packageLoader && (
        <ComparisionTableLayout
          title={ProductPageConstants.compareFeatures.title}
          bundlePackages={bundlePackages}
          openDialog={selectBundleProduct}
          isSelected={getSelectedBundleProduct()}
        />
      )}
      <HelperCardLayout />
      <FAQLayout />
      <Dialog
        open={open}
        handleClose={cancelSelectedProduct}
        submit={checkout}
        title={ProductPageConstants.productContainerDialogTitle.title}
        submitTitle={
          ProductPageConstants.productContainerDialogTitle.submitBtnText
        }
        loading={configLoader}
        showFooter={true}
      >
        <ProductList
          currency={currency.base_currency_symbol}
          products={virtualPackages}
          userCount={attorneySize}
          telligentData={telligentData}
          subscriptionType={subscriptionType}
          contractLength={contractLength}
          selectItem={toggleVirtualProducts}
          selectedItems={selectedVirtualProducts}
          term={
            contractLength.includes("month")
              ? storeData.price_suffix_monthly
              : storeData.price_suffix_yearly
          }
        />
      </Dialog>
    </PageLayout>
  );
};

export default Products;
